import React, {Component} from "react";
import {Link, Route, Switch} from "react-router-dom";
import {Container,Button} from "reactstrap";

import {
	AppAside,
	AppHeader,
	AppSidebar,
	AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
import navigationPro from "../../_navPro";
// routes config
import routes from "../../routes";
import DefaultAside from "./DefaultAside";
import Header from "./Header";
import Fire from "../../components/firebase/Fire";
import APIClient from "../../components/ApolloClientComponent/ApolloClient";
import gql from "graphql-tag";
import Tour from "reactour";
import moment from "moment";
import JobsWithApplicationCountPerJob from "../../gqlQueries/JobsWithApplicationCountPerJob";

class Layout extends Component {
	constructor(props) {
		super(props);

		this.state = {
			notifications: [],
			interviewNotifications: [],
			isLoadingProfile: true,
			isImageLoading: true,
			userSubscriptionType: null,
			jobs: [],
			profile: {
				name: "",
				img: ""
			},
			navigation: navigation,
			navigationPro: navigationPro,
			redirect: false,
			isTourOpen: false,
			isShowingMore: false ,
			startTourSettings : false
		};
		this.getJobsData = this.getJobsData.bind(this);
		this.consumeNotification = this.consumeNotification.bind(this);
		this.loadNotificationsChunk = this.loadNotificationsChunk.bind(this);
		this.populateNotificationElement = this.populateNotificationElement.bind(
			this
		);
		this.loadUserData = this.loadUserData.bind(this);
		this.getJobsData();
	}

	loadUserData(){

		
	
		const currentUserId = Fire.auth().currentUser.uid;

		return APIClient.query({
			fetchPolicy: "network-only",
			query: gql`
				query user($userId: ID!) {
					user(id: $userId) {
						id
						firstName
						lastName
						defaultValues
						subscriptionType
						expiryDate
					}
				}
			`,
			variables: {
				userId: currentUserId
			}
		}).then(({ data: { user } }) => {

			this.setState({
				userSubscriptionType: user.subscriptionType
				
			});

			console.log("The subscription Type is: "+ this.state.userSubscriptionType);

		});


	}

	componentWillMount() {

		this.loadUserData();

		const currentUserId = Fire.auth().currentUser.uid;

		var self = this;

		APIClient.query({
			query: gql`
				query notifications($user: ID!, $cursor: Int) {
					notifications(user: $user, cursor: $cursor) {
						id
						title
						message
						tagType
						tagText
						user
						isConsumed
						unixTimestamp
					}
				}
			`,
			variables: {
				user: currentUserId
			}
		}).then(response => {
			const interviewNotifications = response.data.notifications.filter(ns => ns.tagText === "Interview" && ns.isConsumed !== true);
			const interviewCount = interviewNotifications.length;
			if (interviewCount > 0 ) {
				navigation.items.slice(navigation.items.length - 2, navigation.items.length)[0].badge = {
					text: interviewNotifications.length
				};
				navigationPro.items.slice(navigationPro.items.length - 5, navigationPro.items.length)[0].badge = {
					text: interviewNotifications.length
				};
			}
			const newNotifications = self.state.notifications.slice();
			response.data.notifications.forEach(element => {
				newNotifications.push(this.populateNotificationElement(element));
			});
			self.setState({ notifications: newNotifications, interviewNotifications }); //Update the notifications
		});

		APIClient.subscribe({
			query: gql`
				subscription newNotification($user: ID!) {
					newNotification(user: $user) {
						id
						title
						message
						tagType
						tagText
						user
						isConsumed
						unixTimestamp
					}
				}
			`,
			variables: {
				user: currentUserId
			}
		}).subscribe({
			next(data) {
				const interviewNotifications = data.notifications.filter(ns => ns.tagText === "Interview" && ns.isConsumed !== true);
				const interviewCount = interviewNotifications.length;
				if (interviewCount > 0) {
					navigation.items.slice(navigation.items.length - 2, navigation.items.length)[0].badge = {
						text: interviewNotifications.length
					};
					navigationPro.items.slice(navigationPro.items.length - 2, navigationPro.items.length)[0].badge = {
						text: interviewNotifications.length
					};
				}
				const newNotifications = self.state.notifications.slice();
				data.notifications.forEach(element => {
					newNotifications.push(this.populateNotificationElement(element));
				});
				self.setState({ notifications: newNotifications, interviewNotifications }); //Update the notifications
			},
			error(err) {
				
			}
		});
	}

	handler = () =>{
		document.documentElement.style.zoom = 1.0;
		localStorage.setItem("calendarhelp", true);
		localStorage.setItem("AllJobs", true);
		localStorage.setItem("JobInformation", true);
		localStorage.setItem("candidateInformation", true);
		localStorage.setItem("reportTooltip", true);
		localStorage.setItem("startTour", false);
		this.setState({ isTourOpen: true });
	}
	toggleShowMore = () => {
		this.setState(prevState => ({
			isShowingMore: !prevState.isShowingMore
		}));
	};

	closeTour = () => {
		document.documentElement.style.zoom = 0.8;
		localStorage.setItem("isTourOpen","false");	
		localStorage.setItem("settingsTour","true");	 			
		if(this.state.isTourOpen){			
			this.setState(
				{ 
					isTourOpen: false,
					startTourSettings:true
				}
			);	
		}				
	};

	openTour = () => {
		// console.log("parent>>>"+JSON.stringify(this.props));
		// localStorage.setItem("isTourOpen","true");
		// this.setState({ isTourOpen: true });
	};

	loadNotificationsChunk() {
		const currentUserId = Fire.auth().currentUser.uid;
		/* chunk is of size 10 */
		var self = this;
		APIClient.query({
			query: gql`
				query notifications($user: ID!, $cursor: Int) {
					notifications(user: $user, cursor: $cursor) {
						id
						title
						message
						tagType
						tagText
						user
						isConsumed
						unixTimestamp
					}
				}
			`,
			variables: {
				user: currentUserId,
				cursor:
					self.state.notifications[self.state.notifications.length - 1]
						.unixTimestamp
			}
		}).then(response => {
			var newNotifications = self.state.notifications.slice();
			response.data.notifications.forEach(element => {
				newNotifications.push(this.populateNotificationElement(element));
			});

			self.setState({
				notifications: newNotifications,
				lastIndex: this.state.lastIndex + 10
			}); //Update the notifications
		});
	}
	consumeNotification(item) {
		APIClient.mutate({
			mutation: gql(`
				mutation consumeNotification($id: ID!){
					consumeNotification(id: $id)
				}
			`),
			variables: {
				id: item.id
			}
		});
	}

	populateNotificationElement(element) {
		return {
			id: element.id,
			title: element.title,
			message: element.message,
			tags: [
				{
					type: element.tagType,
					text: element.tagText
				}
			],
			new: !element.isConsumed,
			date: moment.unix(element.unixTimestamp).format("HH:mm:ss DD/MM/YYYY"),
			unixTimestamp: element.unixTimestamp
		};
	}

	getJobsData() {
		const context = this;

		const navStart = navigation.items.slice(0, 2);
		const navEnd = navigation.items.slice(2, navigation.items.length);
		const navStartPro = navigationPro.items.slice(0, 2);
		const navEndPro = navigationPro.items.slice(2, navigationPro.items.length);
		Layout.loadJobs().then((allJobs) => {
			return APIClient.query({
				fetchPolicy: "network-only",
				query: gql`
            query {
                applicationCountByJobPosition {
                    id
                    position
                    statuses
                    total
                }
            }
				`
			}).then((response) => {
				let jobs = allJobs.map(item => {
					return {
						...item,
						sourced: 0,
						newList: 0,
						shortlisted: 0,
						disqualified: 0,
						rejected: 0,
						accepted: 0
					};
				});
				let navJobs = allJobs.map(job => {
					return {
						id: job.id,
						name: job.position.toLowerCase()
							.split(" ")
							.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
							.join(" "),
						url: `/base/requisitions/${job.id}`,
						class: "submenu-item",
						icon: "fa fa-angle-right",
						badge: {
							text: ""
						}
					};
				});

				if (response.data.applicationCountByJobPosition.length > 0) {
					response.data.applicationCountByJobPosition.forEach((job) => {
						let sourced = job.total;
						let newList = 0;
						let shortlisted = 0;
						let disqualified = 0;
						let rejected = 0;
						let accepted = 0;

						job.statuses.forEach((statusInfo) => {
							if (statusInfo.status) {
								switch (statusInfo.status) {
								case 1:
									newList += statusInfo.count;
									break;
								case 2:
									disqualified += statusInfo.count;
									break;
								case 3:
									rejected += statusInfo.count;
									break;
								case 4:
									accepted += statusInfo.count;
									break;
								case 5:
									shortlisted += statusInfo.count;
									break;
								default:
									break;
								}
							} else {
								newList += statusInfo.count;
							}
						});
						let badgeText = "";
						if (newList > 0) {
							badgeText = newList;
						}
						if (jobs.some(item => item.id === job.id)) {
							jobs = jobs.map((item) => {
								if (item.id === job.id) {
									return {
										id: job.id,
										position: job.position,
										sourced: sourced,
										newList: newList,
										shortlisted: shortlisted,
										disqualified: disqualified,
										rejected: rejected,
										accepted: accepted
									};
								}
								return item;
							});
							navJobs = navJobs.map((item) => {
								if (item.id === job.id) {
									return {
										name: job.position.toLowerCase()
											.split(" ")
											.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
											.join(" "),
										url: `/base/requisitions/${job.id}`,
										class: "submenu-item",
										icon: "fa fa-angle-right",
										badge: {
											text: badgeText
										}
									};
								}
								return item;
							});
						} else {
							jobs.push({
								id: job.id,
								position: job.position,
								sourced: sourced,
								newList: newList,
								shortlisted: shortlisted,
								disqualified: disqualified,
								rejected: rejected,
								accepted: accepted
							});
							navJobs.push({
								name: job.position.toLowerCase()
									.split(" ")
									.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
									.join(" "),
								url: `/base/requisitions/${job.id}`,
								class: "submenu-item",
								icon: "fa fa-angle-right",
								badge: {
									text: badgeText
								}
							});
						}
					});
				}
				let finalNav = { items: navStart.concat(navJobs).concat(navEnd) };
				let finalNavPro = {items: navStartPro.concat(navJobs).concat(navEndPro)};
				context.setState({
					navigation: finalNav,
					navigationPro: finalNavPro,
					jobs: jobs,
				});
			})
				.catch((err) => {
					alert(err);
				});
		});
	}

	static loadJobs() {
		return APIClient.query({
			fetchPolicy: "network-only",
			query: JobsWithApplicationCountPerJob
		}).then(result => {
			return result.data.jobs.filter(
				element => element.statusCode === 1 || element.statusCode == undefined || element.statusCode === -3 //Display paused jobs as well
			);
		});
	}

	render() {
		const { isTourOpen } = this.state;
		const accentColor = "#FFFFFF";

		return (
			<div className="app">
				<Tour
					onRequestClose={this.closeTour}
					steps={tourConfig}
					isOpen={isTourOpen}
					maskClassName="mask"
					className="helper"
					rounded={5}
					accentColor={accentColor}
					showNumber={false}
					lastStepNextButton={<Button style={{color:"white", backgroundColor:"#8A5471", borderColor:"#8A5471",boxShadow:"none"}}><i className="fas fa-arrow-right"></i></Button>}
					nextButton={<Button style={{color:"white", backgroundColor:"#8A5471", borderColor:"#8A5471",boxShadow:"none"}}><i className="fas fa-arrow-right"></i></Button>}
					prevButton={<Button style={{color:"white", backgroundColor:"#8A5471", borderColor:"#8A5471",boxShadow:"none"}}><i className="fas fa-arrow-left"></i></Button>}
				/>
				<AppHeader fixed>
					<Header startTourSettings = {this.state.startTourSettings}/>
				</AppHeader>
				<div className="app-body">
					<AppSidebar fixed display="lg" data-tut = "sidebar">
						<AppSidebarNav navConfig={this.state.userSubscriptionType===1 ? this.state.navigationPro: this.state.navigation} {...this.props} />
					</AppSidebar>
					<main className="main">
						<Container fluid style={{ overflow: "auto" }}>
							<Switch>
								{routes.map((route, idx) => {
									return route.component ? (
										<Route
											key={idx}
											path={route.path}
											exact={route.exact}
											name={route.name}

											// component={<route.component/>}
											render={props => <route.component {...props} handler={this.handler}/>}
										/>
									) : null;
								})}
							</Switch>
						</Container>
					</main>
					<AppAside fixed>
						<DefaultAside/>
					</AppAside>
				</div>
			</div>
		);
	}
}

const tourConfig = [
	{
		selector: "[href=\"#/base/jobs\"]",
		content: () => (
			<div>
				<h3>Create a Job </h3>
				<p style={{fontSize:"16px"}}>Kickstart your recruitment by creating a job profile, and find all your jobs here.</p>
			</div>

		),
		style: {
			backgroundColor: "#8A5471",
			color: "white",			
		}
	},
	{
		selector: "[href=\"#/base/resumes\"]",
		content: () => (
			<div>
				<h3>Candidate Pool </h3>
				<p style={{fontSize:"16px"}}>All your candidates are found here - and you can even filter them!</p>
			</div>

		),
		style: {
			backgroundColor: "#8A5471",
			color: "white"
		}
	},
	{
		selector: "[href=\"#/communication/calendar\"]",
		content: () => (
			<div>
				<h3>Calendar</h3>
				<p style={{fontSize:"16px"}}>Set your available times and let candidates schedule themselves.</p>
			</div>

		),		
		style: {
			backgroundColor: "#8A5471",
			color: "white"
		}
	}];

export default Layout;
